<template>
    <div class="form theme-form">
        <div class="">
            <div>
                <h4 class="mb-3 nav-item">
                    <router-link class="nav-link" :to="`/management/products`"
                        :class="{ active: route.path === `/management/products` }">
                        <i class="fa fa-arrow-left"></i> {{ t('Product List') }}</router-link>
                </h4>
                <div class=" d-flex nav nav-pills main-menu email-category">
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link" :to="`/management/products/details/${currentProductID}`"
                            :class="{ active: route.path === `/management/products/details/${currentProductID}` }">{{ t('Basic') }}</router-link>
                    </h4>
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link" :to="`/management/products/details/stock/${currentProductID}`"
                            :class="{ active: route.path.includes('/management/products/details/stock/') }">{{ t('Stock') }}</router-link>
                    </h4>
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link" :to="`/management/products/details/scale/${currentProductID}`"
                            :class="{ active: route.path.includes('/management/products/details/scale/') }">{{ t('Scale') }}</router-link>
                    </h4>
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link" :to="`/management/products/details/set_items/${currentProductID}`"
                            :class="{ active: route.path.includes('/management/products/details/set_items/') }">{{ t('Set Items') }}</router-link>
                    </h4>
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link"
                            :to="`/management/products/details/appearance/${currentProductID}`"
                            :class="{ active: route.path.includes('/management/products/details/appearance/') }">{{ t('Appearance') }}</router-link>
                    </h4>
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link"
                            :to="`/management/products/details/price_levels/${currentProductID}`"
                            :class="{ active: route.path.includes('/management/products/details/price_levels/') }">{{ t('Price Levels') }}</router-link>
                    </h4>
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link"
                            :to="`/management/products/details/condiments/${currentProductID}`"
                            :class="{ active: route.path.includes('/management/products/details/condiments/') }">{{ t('Condiments') }}</router-link>
                    </h4>
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link"
                            :to="`/management/products/details/link_groups/${currentProductID}`"
                            :class="{ active: route.path.includes('/management/products/details/link_groups/') }">{{ t('Link Groups') }}</router-link>
                    </h4>
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link" :to="`/management/products/details/variation/${currentProductID}`"
                            :class="{ active: route.path.includes('/management/products/details/variation/') }">{{ t('Variation') }}</router-link>
                    </h4>
                    <h4 class="mb-3 nav-item">
                        <router-link class="nav-link"
                            :to="`/management/products/details/miscellaneous/${currentProductID}`"
                            :class="{ active: route.path.includes('/management/products/details/miscellaneous/') }">{{ t('Miscellaneous') }}</router-link>
                    </h4>
                </div>
            </div>
            <div class="p-3">
                <router-view></router-view>
            </div>
        </div>
        <div class="text-end mt-3">
            <a class="btn btn-success me-3 px-2" style=" width: 144px;" target="_blank" @click="save()">{{ t('Modify / Save') }}</a>
            <a class="btn btn-danger me-3 px-2" style=" width: 144px;" target="_blank" @click="onRemove()">{{ t('Delete') }}</a>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router';

import { useProductsStore } from '@/store/management/productsStore';
import Swal from 'sweetalert2'
import router from '@/router';

import { useI18n } from 'vue-i18n'
import { productDetailsLanguage } from '@/core/locales/products-language'

const { t } = useI18n({
  messages: productDetailsLanguage
})

const productStore = useProductsStore()
const route = useRoute()

const currentProductID = computed(() => {
    return Array.isArray(route.params.id) ? route.params.id[0] : route.params.id
})

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})


const save = () => {
    console.log(tempActiveProduct.value);
    productStore.updateProduct(tempActiveProduct.value);
    Swal.fire({
        icon: "success",
        title: "success!",
        text: "Tax details updated successfully",
        confirmButtonColor: 'var(--theme-default)',
    }).then(() => {
        console.log(productStore.getAllProducts('all', ''));
        // router.push('/management/products');
    });
}

const onRemove = () => {
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ff0000', // Red color for confirm button
        cancelButtonColor: '#dfdfdf', // Black color for cancel button
        confirmButtonText: 'Confirm',
    }).then((result) => {
        if (result.isConfirmed) {
            productStore.removeProduct(activeProduct.value.basic.id)
            Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
            )
        }
    }).then(() => {
        router.push('/management/products')
    })
}

onMounted(() => {
    const currentProductNumber = Array.isArray(route.params.id) ? route.params.id[0] : route.params.id
    const currentProductData = productStore.getProductDataById(currentProductNumber)
    if (currentProductData) {
        productStore.initActiveProduct(currentProductData)
    } else {
        router.push('/management/products')
    }
})
</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}


.nav-link {
    color: var(--bs-heading-color);
}
</style>